import styled from 'styled-components'
import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions,
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../stories/fundamentals/text-styles/constants'
import colorsOptions from '../stories/fundamentals/colors-styles/constants'

export const BlockMoveMultipleItemsMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const TotaItems = styled.div`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]}
  color: ${colorsOptions.semantics.danger['error-50']};
`

export const MoveMultipleItemsMessage = styled.div`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]}
  color: ${colorsOptions.semantics.danger['error-50']};
`

export const BlockedItemsList = styled.ul`
  padding: 0.5rem 0 0.5rem 0.75rem;
  list-style: none;
`

export const BlockedItemsListItem = styled.li`
  position: relative;
  padding-left: 12px;

  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]}
  color: ${colorsOptions.semantics.danger['error-50']};

  &::before {
    content: '';
    position: absolute;
    left: 0;

    width: 3px;
    height: 3px;

    border: 1px solid ${colorsOptions.semantics.danger['error-50']};
    background: ${colorsOptions.semantics.danger['error-50']};
    border-radius: 50%;

    top: 50%;
    transform: translateY(-50%);
  }
`

// Not allowed move items alert

export const NotAllowedItemsDescription = styled.div`
  color: ${colorsOptions.greys['grey-100']};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]}
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const NotAllowedList = styled.ul`
  list-style-type: disc;
  padding-left: 1.25rem;

  li {
    list-style-type: disc;
  }
`
